export const IMP_STATUS = {
  bozza: ["Bozza", "bg-zinc-100 text-zinc-700 border-zinc-200"],
  in_attesa_firma: ["In attesa di firma", "bg-amber-50 text-amber-800 border-amber-200"],
  firmata: ["Firmata", "bg-emerald-50 text-emerald-700 border-emerald-200"],
  in_consegna: ["In consegna", "bg-sky-50 text-sky-700 border-sky-200"],
  consegnata: ["Consegnata e completata", "bg-emerald-600 text-white border-emerald-600"],
  annullata: ["Annullata", "bg-red-50 text-red-700 border-red-200"],
};

const r2 = (v) => Math.round((Number(v) || 0) * 100 + 1e-7) / 100;

export function impTotals(d) {
  const goods = r2(d.items.reduce((s, i) => s + (Number(i.qty) || 0) * (Number(i.price) || 0), 0));
  const total = r2(goods + r2(d.transport) + r2(d.assembly) + r2(d.other_costs));
  return { goods, transport: r2(d.transport), assembly: r2(d.assembly), other_costs: r2(d.other_costs), total, paid: r2(d.paid), balance: r2(total - r2(d.paid)) };
}

export const newImpItem = () => ({ key: crypto.randomUUID(), description: "", qty: 1, price: "", notes: "" });

export const emptyImp = () => ({
  customer_id: "", appointment_id: "",
  customer: { name: "", phone: "", address: "", access_info: "" },
  items: [newImpItem()],
  transport: "", assembly: "", other_costs: "", other_costs_desc: "", paid: "", paid_type: "acconto",
  delivery: { address: "", date: "", time_slot: "", floor_info: "", staff_notes: "", services: { trasporto: false, montaggio: false, altro: "" } },
  specific_agreements: "",
});

const num = (v) => Number(String(v ?? "").replace(",", ".")) || 0;

export const toPayload = (f) => ({
  ...f,
  items: f.items.map(({ key, ...i }) => ({ ...i, qty: parseInt(i.qty, 10) || 1, price: num(i.price) })),
  transport: num(f.transport), assembly: num(f.assembly), other_costs: num(f.other_costs), paid: num(f.paid),
});

export const fromData = (d) => ({ ...d, items: d.items.map((i) => ({ ...i, key: crypto.randomUUID() })) });
